/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import abstractContractClaimTranslations from "./abstractContractClaimTranslations";

const travelContractTranslations = {
  label: "Reisevertrag",
  reasonForDispute: {
    label: "Problem mit Reise",
    options: {
      cancelled: {label: "Die Reise wurde abgesagt"},
      participationImpossible: {label: "Ich kann nicht teilnehmen"},
      notAsAdvertised: {label: "Die Reise entsprach nicht der Beschreibung"},
      other: {label: "Ich habe ein anderes Anliegen"},
    },
  },
  contractNumber: {
    label: "Buchungs- oder Kundennummer",
  },
  bookingDate: {
    label: "Tag der Buchung",
  },
  journeyStart: {
    label: "Start der Reise",
  },
  journeyEnd: {
    label: "Ende der Reise",
  },
  contractualPartnerHasCancelled: {
    label: "Absage durch Reiseanbieter?",
    options: {
      true: {label: "Ja"},
      false: {label: "Nein"},
    },
  },
  contractualPartnerCancellationDate: {
    label: "Datum Absage Reiseanbieter",
  },
  buyerPaidDate: {
    label: "(Letzte) Zahlung am",
  },
  buyerPaidAmount: {
    label: "Geleistete Zahlung",
    question: "Wie viel haben Sie insgesamt bereits bezahlt?",
  },
  ...abstractContractClaimTranslations,
};

export default travelContractTranslations;
